import React, { useEffect, useRef, useState } from 'react';
import normalizeWheel from 'normalize-wheel';
import { observer } from 'mobx-react';
import TreeCanvasBlock from './TreeCanvasBlock';
import { padding } from './renderTreeCanvas';
const TreeCanvas = observer(function ({ model }) {
    const ref = useRef(null);
    const scheduled = useRef(false);
    const deltaY = useRef(0);
    const prevY = useRef(0);
    const { treeWidth, height, blocksY } = model;
    const [mouseDragging, setMouseDragging] = useState(false);
    useEffect(() => {
        const curr = ref.current;
        if (!curr) {
            return;
        }
        function onWheel(origEvent) {
            const event = normalizeWheel(origEvent);
            deltaY.current += event.pixelY;
            if (!scheduled.current) {
                scheduled.current = true;
                requestAnimationFrame(() => {
                    model.doScrollY(-deltaY.current);
                    deltaY.current = 0;
                    scheduled.current = false;
                });
            }
            origEvent.preventDefault();
        }
        curr.addEventListener('wheel', onWheel);
        return () => {
            curr.removeEventListener('wheel', onWheel);
        };
    }, [model]);
    useEffect(() => {
        let cleanup = () => { };
        function globalMouseMove(event) {
            event.preventDefault();
            const currY = event.clientY;
            const distanceY = currY - prevY.current;
            if (distanceY) {
                // use rAF to make it so multiple event handlers aren't fired per-frame
                // see https://calendar.perfplanet.com/2013/the-runtime-performance-checklist/
                if (!scheduled.current) {
                    scheduled.current = true;
                    window.requestAnimationFrame(() => {
                        model.doScrollY(distanceY);
                        scheduled.current = false;
                        prevY.current = event.clientY;
                    });
                }
            }
        }
        function globalMouseUp() {
            prevY.current = 0;
            if (mouseDragging) {
                setMouseDragging(false);
            }
        }
        if (mouseDragging) {
            window.addEventListener('mousemove', globalMouseMove, true);
            window.addEventListener('mouseup', globalMouseUp, true);
            cleanup = () => {
                window.removeEventListener('mousemove', globalMouseMove, true);
                window.removeEventListener('mouseup', globalMouseUp, true);
            };
        }
        return cleanup;
    }, [model, mouseDragging]);
    function mouseDown(event) {
        // check if clicking a draggable element or a resize handle
        const target = event.target;
        if (target.draggable || target.dataset.resizer) {
            return;
        }
        // otherwise do click and drag scroll
        if (event.button === 0) {
            prevY.current = event.clientY;
            setMouseDragging(true);
        }
    }
    // this local mouseup is used in addition to the global because sometimes
    // the global add/remove are not called in time, resulting in issue #533
    function mouseUp(event) {
        event.preventDefault();
        setMouseDragging(false);
    }
    function mouseLeave(event) {
        event.preventDefault();
    }
    return (React.createElement("div", { ref: ref, onMouseDown: mouseDown, onMouseUp: mouseUp, onMouseLeave: mouseLeave, style: {
            height,
            position: 'relative',
            overflow: 'hidden',
            width: treeWidth + padding,
        } }, blocksY.map(block => (React.createElement(TreeCanvasBlock, { key: block, model: model, offsetY: block })))));
});
export default TreeCanvas;
//# sourceMappingURL=TreeCanvas.js.map